module.exports = __webpack_public_path__ + "static/media/checked.7868c805.svg";